const PATH = '/group/:f([a-z0-9-]{0,}?)?-:groupId([a-z0-9]{6,})';

export default {
  path: PATH,

  load: (context: any, params: any) => import(/* webpackChunkName: 'group' */ './index'),
};
